import React from 'react';

import { Button, Link } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const CancelButton: React.FC = () => {
  const { t } = useTranslation('pages.forgetPassword.form');
  return (
    <Button colorScheme="secondary" w="full" as={Link} href={routes.signIn.url}>
      {t('backToLogin')}
    </Button>
  );
};

export default CancelButton;
